/* eslint-disable func-names */
/* eslint-disable object-shorthand */
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-balham.css';
import './index.scss';

import AgGridReactComponent from '../../../../common/components/ag-grid-react-component';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import React from 'react';
import { formatGivenDate } from '../../../../shared/services/common-functions';

function onGridReady(params) {
    setTimeout(() => {
        params.api.sizeColumnsToFit();
    }, 500);
}

const orderBuildWeekValueForDetailGetter = params => {

    const orderBuildWeek = formatGivenDate( params.data.orderBuildWeek, 'YYYY-MM-DD' );

    if ( orderBuildWeek === '' ) return ( <span>{orderBuildWeek}</span> );
    if ( orderBuildWeek === '2000-01-01' ) {

        return 'Inventory';

    } if ( orderBuildWeek === '2000-02-01' ) {

        return 'Rework';

    }
    return orderBuildWeek;

};

const itemBuildWeekValueGetter = params => {

    const itemBuildWk = formatGivenDate( params.data.itemBuildWeek, 'YYYY-MM-DD' );

    if ( itemBuildWk === '' ) return ( <span>{itemBuildWk}</span> );
    if ( itemBuildWk === '2000-01-01' ) {

        return 'Inventory';

    } if ( itemBuildWk === '2000-02-01' ) {

        return 'Rework';

    }
    return itemBuildWk;

};

const colDefs = [
    {
        field: 'family',
        headerName: 'Family',
        sortable: true,
        filter: true,
        width: 150
    },
    {
        field: 'orderingCode',
        headerName: 'Ordering Code',
        sortable: true,
        width: 150,
        cellRenderer: params => {

            if ( params.value === '' ) return ( <span>{params.value}</span> );
            if ( ( params.data.reportType === 'Bundle' || params.data.reportType === 'Combo' ) && ( params.data.orderOrGroup === 'B' || params.data.orderOrGroup === 'P' ) ) {

                return ( <Link to={`/${params.data.unitName}/order/availability?constrainttype=BN&constraintkey=${params.value}&week=${formatGivenDate( params.data.itemBuildWeek, 'YYYY-MM-DD' )}`}>{params.value}</Link> );

            } if ( params.data.orderOrGroup === 'M' ) {

                return ( <Link to={`/${params.data.unitName}/order/availability?constrainttype=B&constraintkey=${params.value}&week=${formatGivenDate( params.data.itemBuildWeek, 'YYYY-MM-DD' )}`}>{params.value}</Link> );

            } if ( params.data.orderOrGroup === 'A' ) {

                return ( <span>{params.value}</span> );

            }
            return ( <Link to={`/${params.data.unitName}/order/availability?constrainttype=${params.data.orderOrGroup}&constraintkey=${params.value}&week=${formatGivenDate( params.data.itemBuildWeek, 'YYYY-MM-DD' )}`}>{params.value}</Link> );

        }
    },
    {
        field: 'qty',
        headerName: 'Qty',
        sortable: true,
        filter: true,
        width: 80,
        cellRenderer: params => {

            if ( params.value === '' || params.value === 0 || params.value === 1 ) return ( <span>{params.value}</span> );
            return ( <Link to={`/${params.data.unitName}/constraints/check-orders-order-code?family=${params.data.family}&orderingcode=${params.data.orderingCode}&orderbuildweek=${formatGivenDate( params.data.orderBuildWeek, 'YYYY-MM-DD' )}&dateType=FUTURE`}>{params.value}</Link> );

        }
    },
    {
        field: 'itemBuildWeek',
        headerName: 'Item Build Week',
        sortable: true,
        filter: true,
        width: 170,
        valueGetter: itemBuildWeekValueGetter
    },
    {
        field: 'orderBuildWeek',
        headerName: 'Order Build Week',
        sortable: true,
        filter: true,
        width: 170,
        valueGetter: orderBuildWeekValueForDetailGetter
    },
    {
        field: 'orderNumber',
        headerName: 'Order Number',
        sortable: true,
        filter: true,
        width: 150
    },
    {
        field: 'orderOrGroup',
        headerName: 'Order or Group',
        sortable: true,
        filter: true,
        width: 150
    }
];

const CountingBundleEarlierOrderTable = props => (

    <section className="atp-search-result-panel counting-bundle-earlier-order-result-panel">

        <div className="atp-ag-grid ag-theme-balham ag-theme-popupbg">
            <AgGridReactComponent
                reactNext={true}
                columnDefs={colDefs}
                rowData={props.results}
                onGridReady={onGridReady}
            />
        </div>

    </section>
);

CountingBundleEarlierOrderTable.propTypes = {
    results: PropTypes.array.isRequired
};
export default CountingBundleEarlierOrderTable;
